import React from 'react'
import Link from 'gatsby-link'
import logo from '../images/logo_color.svg'
import $ from 'jquery'
import { track_click }  from '../components/tracking'

const Header = ({ siteTitle, Pages }) => {
  let _Pages = []
  for (let ip = 0; ip < Pages.length; ip++) {
    let _page1 = Pages[ip];
    if(_page1.node.context != undefined && _page1.node.context.node != null)
    {
      _Pages.push(_page1);
    }
    
  }
  _Pages.sort((a,b) => {return a.node.context.node.index - b.node.context.node.index } );

  let _index = 0;
  
  function cerrarMenu(e){
    track_click("UCLCerrarIndice");
    e.preventDefault();
    $('.menu_desplegado').fadeOut();
    $('body').css('background', 'initial')
   // $('.header_internal').css('position', 'initial').css('background','transparent')
  }
  function goHome(e)
  {
    track_click("UCLIndiceVolverPortada");
    window.location.href = process.env.PREFIX_PATH + "/";
  }

  function abrirMenu(e){
    track_click("UCLIndice");
    e.preventDefault();
   $('.menu_desplegado').fadeIn();
   $('body').css('background', 'rgba(0,0,0, .4)')
  // $('.header_internal').css('position', 'sticky').css('top','0').css('background','rgba(255,255, 255, 1)')
  }
  return(
    <div className="header_internal" style={{  zIndex:'1'}}>
      <div
        style={{
          margin: '0 auto',
          lineHeight: '65px',
          textAlign: 'center',
          height: '65px'
        }}
      >
      <div className="menu_texto" onClick={abrirMenu}><span>ÍNDICE</span></div>
      <div className="menu_desplegado menu_internal">
      <div className="volver">
        <span onClick={goHome}>VOLVER A PORTADA</span>
        <span className="cerrar" onClick={cerrarMenu}>X</span>
      </div>
      <ul>
        {
           _Pages.map(({ node }, index) => {
            if((node.path != '/internal/' && node.path != 'dev-404-page/' && node.path != '/404/' && node.path != '/404.html' && node.path != '/dev-404-page/' && node.path != '/')
            && (node.context.node.type != "video"))
            {
              _index++;
                return (
                <li key={index} className="li_capitulo">
                    <a href={ process.env.PREFIX_PATH + node.path }> 
                    {/* <a href={ node.path.substring(1) }> 
                      <div>{ node.context.node.label }</div>*/}
                      <div>{node.context.node.title}</div>
                    </a>
                </li>
              )
            }
           })
        }
      </ul>
    </div>
       <a href="//www.univision.com/deportes">
        <div className="logo_univision_interna"></div>
       </a>
        <span  className="slash">/ </span>
        <h1 className="titulo_despliegue internal">
          <Link
            to="/"
            style={{
              color: 'white',
              textDecoration: 'none',
            }}
          >
            {siteTitle}

          </Link>
          <a href={"https://www.univision.com/deportes/futbol/uefa-champions-league"}>
          UEFA CHAMPIONS League
          </a>
        </h1>
      </div>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/headerInternal.js